import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Scroll } from "@phosphor-icons/react";

export default function AuditTab({ auction }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(`/auctions/${auction.id}/audit-logs`); setLogs(data); }
      finally { setLoading(false); }
    })();
  }, [auction.id]);

  return (
    <div className="space-y-4" data-testid="audit-tab">
      <div className="label-mono">AUDIT · {logs.length} entries</div>
      {loading ? (
        <div className="label-mono py-16 text-center">Loading…</div>
      ) : logs.length === 0 ? (
        <div className="border border-dashed border-gray-200 rounded p-10 text-center text-gray-500" data-testid="audit-empty">
          No activity recorded yet.
        </div>
      ) : (
        <div className="bg-slate-50 border border-gray-200 rounded overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-white text-left">
              <tr className="text-xs">
                <th className="px-4 py-2 label-mono">When</th>
                <th className="px-4 py-2 label-mono">Actor</th>
                <th className="px-4 py-2 label-mono">Action</th>
                <th className="px-4 py-2 label-mono">Details</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-t border-gray-100 hover:bg-white/50" data-testid={`audit-row-${l.id}`}>
                  <td className="px-4 py-2 font-mono text-xs text-gray-500 whitespace-nowrap">{new Date(l.at).toLocaleString()}</td>
                  <td className="px-4 py-2 text-xs">
                    <div className="font-semibold text-slate-900">{l.actor_email}</div>
                    <div className="label-mono">{l.actor_role}</div>
                  </td>
                  <td className="px-4 py-2 text-xs font-mono text-emerald-600 whitespace-nowrap">{l.action}</td>
                  <td className="px-4 py-2 text-xs text-gray-500">
                    {l.meta && Object.keys(l.meta).length > 0 ? (
                      <pre className="text-xs bg-white rounded p-2 overflow-x-auto max-w-md whitespace-pre-wrap break-words">
                        {JSON.stringify(l.meta, null, 2)}
                      </pre>
                    ) : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
